import type { RestoreAccount } from '@repo/api-gw-sdk';

const principalsArray = (providerAccountIds: string[]) =>
  providerAccountIds
    .map((id) => `\n        "arn:aws:iam::${id}:root"`)
    .join(',');

const arnLikeArray = (providerAccountIds: string[]) =>
  providerAccountIds
    .map((id) => `\n          "arn:aws:iam::${id}:role/Eon*"`)
    .join(',');

export const getKmsKeyPolicyStatements = (
  scanningAccountIds: string[],
  awsRestoreAccounts: RestoreAccount[]
) => {
  if (scanningAccountIds.length === 0) {
    return '';
  }

  const scanningPrincipals = principalsArray(scanningAccountIds);
  const scanningArnLike = arnLikeArray(scanningAccountIds);

  const scanningPolicy = `
  {
    "Sid": "Allow key usage in scanning account",
    "Effect": "Allow",
    "Principal": {
      "AWS": [${scanningPrincipals}
      ]
    },
    "Action": [
      "kms:DescribeKey",
      "kms:Encrypt",
      "kms:Decrypt",
      "kms:ReEncrypt*",
      "kms:GenerateDataKey*"
    ],
    "Resource": "*",
    "Condition": {
      "ArnLike": {
        "aws:PrincipalArn": [${scanningArnLike}
        ]
      }
    }
  },
  {
    "Sid": "Allow grant for snapshot copy in scanning account",
    "Effect": "Allow",
    "Principal": {
      "AWS": [${scanningPrincipals}
      ]
    },
    "Action": "kms:CreateGrant",
    "Resource": "*",
    "Condition": {
      "Bool": {
        "kms:GrantIsForAWSResource": "true"
      },
      "ArnLike": {
        "aws:PrincipalArn": [${scanningArnLike}
        ]
      }
    }
  }`;

  if (awsRestoreAccounts.length === 0) {
    return scanningPolicy;
  }

  const restorePrincipals = principalsArray(
    awsRestoreAccounts.map((a) => a.providerAccountId)
  );
  const restoreArnLike = arnLikeArray(
    awsRestoreAccounts.map((a) => a.providerAccountId)
  );

  const restorePolicy = `,
  {
    "Sid": "Allow key usage for restore node role and db query",
    "Effect": "Allow",
    "Principal": {
      "AWS": [${restorePrincipals}
      ]
    },
    "Action": [
      "kms:DescribeKey",
      "kms:Encrypt",
      "kms:Decrypt",
      "kms:ReEncrypt*",
      "kms:GenerateDataKey*"
    ],
    "Resource": "*",
    "Condition": {
      "ArnLike": {
        "aws:PrincipalArn": [${restoreArnLike}
        ]
      }
    }
  },
  {
    "Sid": "Allow grant for snapshot restore",
    "Effect": "Allow",
    "Principal": {
      "AWS": [${restorePrincipals}
      ]
    },
    "Action": "kms:CreateGrant",
    "Resource": "*",
    "Condition": {
      "Bool": {
        "kms:GrantIsForAWSResource": "true"
      },
      "ArnLike": {
        "aws:PrincipalArn": [${restoreArnLike}
        ]
      }
    }
  }`;

  return `${scanningPolicy}${restorePolicy}`;
};
